<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="400px"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-input v-model="remarks" placeholder="请输入"></el-input>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right;"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
        >保存</el-button>
        <el-button
          style="width: 106px; float: right;  margin-right: 15px;"
          size="small"
          @click="close()"
        >取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
var thisInfo = {};

export default {
  data() {
    return {
      changVisible: false,
      title: "修改校友备注信息",
      remarks: "",
      clickLastTime: 0, //默认上一次点击时间为0
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;

      if (this.remarks.length > 25) {
        this.$message.error("备注限制25个字符");
        return;
      }
      this.changVisible = false;
      this.$emit("toSave", this.remarks);
    },
    //页面初始化时加载的事件
    show(remarks) {
      this.remarks = remarks;
      this.changVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/modifyRemarksDialog.vue